<script lang="ts">
  interface Props {
    /** 1-indexed current round number. */
    current: number;
    /** Total rounds in this run. */
    total: number;
  }

  let { current, total }: Props = $props();
</script>

<div class="round-counter" aria-live="polite">
  Round <span class="round-counter__current">{current}</span><span class="round-counter__divider">/</span><span class="round-counter__total">{total}</span>
</div>
